import {FC} from 'react';

import {Skeleton, Stack, Typography} from '@mui/material';
import i18n, {t} from 'i18next';

import LargeChevronRight from 'assets/icons/largeChevronRight';
import {useAppSelector} from 'hooks';
import ReactNative from 'services/react-native';
import {ShippingAddressType} from 'types';
import {getStringFormOfAddress} from 'utils/address';

import {
  ShipToLabelWrapper,
  ShippingAddressWrapper,
  CompleteMyAddressWrapper,
  StyledChevronRight,
  StyledPinDrop
} from './styles';

export const ShippingAddress: FC<ShippingAddressType> = ({
  address,
  isLoading: isLoadingAddress,
  onClick: clickCallback
}) => {
  const {idToken} = useAppSelector((state) => state?.auth) || {};
  const currentStore = useAppSelector((state) => state?.app?.currentStore);
  const zipCode = currentStore?.zipcode || '';
  const isThai = i18n.language === 'th';
  const isReactNativeView = ReactNative.isReactNativeWebView();

  const addressLine = () => {
    if (address === undefined) {
      return (
        <>
          {zipCode}
          <CompleteMyAddressWrapper> ({t('label.completeMyAddress')})</CompleteMyAddressWrapper>
        </>
      );
    }

    if (!address.address1) {
      return (
        <>
          {address.zip}
          <CompleteMyAddressWrapper> ({t('label.completeMyAddress')})</CompleteMyAddressWrapper>
        </>
      );
    }

    return getStringFormOfAddress(address, isThai, false);
  };

  const ShippingAddressSkeleton = () => (
    <Stack spacing={1}>
      <Skeleton variant="rectangular" height={30} sx={{borderRadius: 2}} />
    </Stack>
  );

  const onShippingAddressClick = () => {
    if (!idToken) {
      // router.replace(getAuthRedirectURI(i18n.language, 'auth/login'));
    } else {
      clickCallback && clickCallback();
    }
  };

  if (!idToken) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: isReactNativeView ? '#F4F4F4' : 'white',
        boxShadow: isReactNativeView ? '0px 4px 12px 0px rgba(0, 0, 0, 0.08)' : 'none',
        zIndex: isReactNativeView ? '1000' : 'none'
      }}
      data-test-id={'basket_shipping_address'}
    >
      {isLoadingAddress ? (
        <ShippingAddressSkeleton />
      ) : (
        <ShippingAddressWrapper
          onClick={() => {
            onShippingAddressClick();
          }}
          isReactNativeView={isReactNativeView}
        >
          <StyledPinDrop sx={{fontSize: 18}} color="primary" />
          <ShipToLabelWrapper>
            <Typography>
              <b>{t('label.shipTo')}</b>
            </Typography>
          </ShipToLabelWrapper>
          <Typography overflow={'hidden'} flexGrow={1} textOverflow={'ellipsis'} whiteSpace={'nowrap'}>
            {addressLine()}
          </Typography>
          {isReactNativeView ? <LargeChevronRight /> : <StyledChevronRight />}
        </ShippingAddressWrapper>
      )}
    </div>
  );
};

ShippingAddress.displayName = 'ShippingAddess';

export default ShippingAddress;
